import React from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {Form} from 'semantic-ui-react';
import {dateFormatPicker} from '../../../common/constants/datesFormat';
import {CAMPAIGN_STATUS} from '../../constants';

const campaignStatus = CAMPAIGN_STATUS.slice(1);

const CampaignInfo = ({
  handleChange,
  campaingNo,
  campaingName,
  createDate,
  detail,
  sscCode,
  status,
  user,
  edit,
}) => {
  return (
    <React.Fragment>
      <div className='campaign-form-group'>
        <Form.Input
          fluid
          label='Código SSC'
          placeholder='Código SSC'
          required
          value={sscCode || ''}
          onChange={(e, {value}) => handleChange('sscCode', value)}
        ></Form.Input>
        <Form.Input
          fluid
          label='Nombre de campaña de servicio'
          placeholder='Nombre de campaña'
          required
          value={campaingName || ''}
          onChange={(e, {value}) => handleChange('campaingName', value)}
        ></Form.Input>
        <Form.Input
          fluid
          label='Número de campaña'
          placeholder='Número de campaña'
          value={campaingNo || ''}
          readOnly
        ></Form.Input>
      </div>
      <div className='campaign-form-group'>
        <Form.Dropdown
          fluid
          selection
          label='Estado'
          placeholder='Estado'
          options={campaignStatus}
          disabled={!edit}
          value={status || 'A'}
          onChange={(e, {value}) => handleChange('status', value)}
        ></Form.Dropdown>
        <Form.Input
          fluid
          label='Usuario de creación'
          placeholder='Usuario'
          value={user || ''}
          readOnly
          onChange={(e, {value}) => handleChange('user', value)}
        ></Form.Input>
        <Form.Input fluid label='Fecha de creación' readOnly>
          <DatePicker
            readOnly
            placeholderText='Fecha de creación'
            className='tcc-datepicker'
            showYearDropdown
            selected={createDate ? moment(createDate).toDate() : null}
            dateFormat={dateFormatPicker}
            onChange={(value) => handleChange('createDate', value)}
            locale='es'
          />
        </Form.Input>
      </div>
      <Form.TextArea
        label='Detalle'
        placeholder='Detalle'
        required
        error={!detail}
        value={detail || ''}
        onChange={(e, {value}) => handleChange('detail', value)}
      ></Form.TextArea>
    </React.Fragment>
  );
};

export default CampaignInfo;
